/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
// module
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SocialChatComponent } from './social-chat.component';
import { TranslateModule } from '@ngx-translate/core';
import { NumberAcceptModule } from '../../shared/validation-directives/onlyNumber.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChatService } from '../../../core/chat/chat.service';
import { ChatDialog } from '../social-hub-user/chat-popup/chat-popup.component';
import { MatDialogModule } from '@angular/material/dialog';


// export const routes = [
//     { path: '', component: SocialChatComponent, pathMatch: 'full' }
// ];

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
      //  RouterModule.forChild(routes),
        // SharedModule,
        // ComponentsModule,
        TranslateModule.forChild(),
        NumberAcceptModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    declarations: [
        SocialChatComponent,
        ChatDialog
    ],
    exports: [SocialChatComponent],
    providers: [ChatService],
    entryComponents:[ChatDialog]
})
export class SocialChatModule {
}
